import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=5e33e1f0&scoped=true"
import script from "./UploadFiles.vue?vue&type=script&lang=js"
export * from "./UploadFiles.vue?vue&type=script&lang=js"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=5e33e1f0&prod&lang=scss"
import style1 from "./UploadFiles.vue?vue&type=style&index=1&id=5e33e1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e33e1f0",
  null
  
)

export default component.exports